import imageLoader from "components/media/imageLoader"
import Back from "components/nav-v2/Back"
import Tools from "components/nav-v2/Tools"
import SubNav from "components/sub-nav/Pane"
import Content from "components/testimonee/TestimoneeContent"
// import TestimoneeExplore from "components/testimonee/testimonee-explore/TestimoneeExplore"
import { useConsole } from "contexts/Console"
import { useDictionary } from "contexts/Dictionary"
import { useEnv } from "contexts/Env"
import { useLocale } from "contexts/Locale"
import { useNavigation } from "contexts/Navigation"
import { usePage } from "contexts/Page"
import { useSuspender } from "contexts/Suspender"
import { useUser } from "contexts/User"
import useSSR from "hooks/useSSR"
import { Suspense, useEffect } from "react"
import { Helmet } from "react-helmet-async"
import { useParams } from "react-router-dom"
import camelCase from "utils/camelCase"
import generateComponents from "utils/generateComponents"

export const aggregatorPathByTerm = {
  arts: "perpetual-arts",
  planet: "perpetual-planet",
  sports: "rolex-and-sports",
}

const getAggregatorPath = event => {
  const aggregatorTerm = event?.taxonomies?.find(item => item.taxonomy_uid === "aggregator")?.term_uid
  return aggregatorPathByTerm[aggregatorTerm]
}

export default function BootstrapEvent(props) {
  const console = useConsole()
  const locale = useLocale()
  const navigation = useNavigation()
  const dictionary = useDictionary()
  const env = useEnv()
  const user = useUser()
  const { discipline, parent_element: parentSlug, event: slug } = useParams()
  const page = usePage()
  const ssr = useSSR()
  const pageAggregator = page.url?.split("/").filter(Boolean).at(0)

  const { controlsLayout, header, footer, nofooter } = props
  const { cloudinary: { secureDistribution } = {} } = env
  const { share } = page

  const path = navigation.localize(`/event/${slug}.extra.json`, locale.current.codes.www)

  const [[err, event], eventSSR] = useSuspender(
    ["event", path, locale.current.codes.www, pageAggregator, discipline, parentSlug],
    () =>
      Promise.resolve(new URL(path, process.browser ? global.location.origin : process.env.REVERSE_PROXY_URL))
        .then(url => fetch(url))
        .then(response => response.json())
        .then(event => {
          const disciplineTerm = event.taxonomies?.find(item => item.taxonomy_uid === "discipline")?.term_uid?.replaceAll("_", "-")
          const aggregator = getAggregatorPath(event)
          const expectedParentSlug = event.parent_element?.[0]?.slug

          if (!aggregator || pageAggregator !== aggregator || event.slug !== slug || discipline !== disciplineTerm || parentSlug !== expectedParentSlug) {
            throw Object.assign(new Error("Not Found"), { status: 404 })
          }

          if (Array.isArray(event.tags)) {
            const excludedCountries = event.tags
              .filter(tag => typeof tag === "string" && tag.startsWith("exclude:"))
              .map(tag => tag.split("exclude:")[1].toLowerCase())

            if (user.countryCode && excludedCountries.includes(user.countryCode.toLowerCase())) {
              throw Object.assign(new Error("Not Found"), { status: 404 })
            }
          }

          /* Uncomment the following lines for `dynamic` page metas */

          // const title = page?.meta?.title.replaceAll("%name%", event.name || "")
          // const description = page?.meta?.description.replaceAll("%name%", event.name || "")
          // const ogtitle = (page?.meta?.title_og || page?.meta?.title || "").replaceAll("%name%", event.name || "")
          // const ogdescription = (page?.meta?.description_og || page?.meta?.description || "").replaceAll("%name%", event.name || "")
          // const ogimage = generateMetaImageUrl(page?.meta?.image_og, secureDistribution)

          // event.pageMeta = { title, description, ogtitle, ogdescription, ogimage }

          // if (event.watch?.rmc) {
          //   return Promise.resolve(
          //     new URL(
          //       `/api/catalog/watches/${event.watch.rmc}?language=${locale.current.codes.ws}`,
          //       process.browser ? env.services : process.env.SERVICE_CATALOG_URL
          //     )
          //   )
          //     .then(catalogUrl => fetch(catalogUrl))
          //     .then(catalogResponse => catalogResponse.json())
          //     .then(catalogData => {
          //       event.watch.catalog = catalogData
          //       return [null, event]
          //     })
          //     .catch(error => {
          //       console.error(error)
          //       return [error, event]
          //     })
          // }

          return [null, event]
        })
        .catch(err => [err, {}]),
    true
  )

  if (err) {
    if (process.browser) navigation.push(navigation.localize("/404"))
    throw err
  }

  // const [[error, events], eventsSSR] = useSuspender(
  //   ["event", event.uid, user.countryCode, discipline, locale?.current?.codes?.www],
  //   async () => {
  //     try {
  //       const token = !process.browser ? env.__unsafe.coveo[3] : global.accessTokens.pipelineTestimonees
  //       const url = env.endpoint
  //       const lang = locale?.current?.codes?.www === "en" ? "en-GB" : locale?.current?.codes?.www
  //       const country = user.countryCode.toLowerCase()
  //       const cs_uid = event.uid

  //       const classification = event.taxonomies
  //         .filter(item => item.taxonomy_uid === "classification")
  //         .map(item => item.term_uid)
  //         .join(";")

  //       const market = event.taxonomies
  //         .filter(item => item.taxonomy_uid === "market")
  //         .map(item => item.term_uid)
  //         .join(";")

  //       const request = new Request(url, {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //         body: JSON.stringify({
  //           q: "event",
  //           generateJson: true,
  //           cq: `@rlx_lang==${lang}`,
  //           searchHub: env.pipelineEvent,
  //           fieldsToInclude: [
  //             "slug",
  //             "title",
  //             "discipline",
  //             "public_id_image_0",
  //             "public_image_0_width",
  //             "public_image_0_height",
  //             "public_id_image_1",
  //             "public_image_1_width",
  //             "public_image_1_height",
  //             "public_id_image_2",
  //             "public_image_2_width",
  //             "public_image_2_height",
  //             "cs_uid",
  //           ],
  //           numberOfResults: 6,
  //           firstResult: 0,
  //           sortCriteria: "relevancy",
  //           enableDidYouMean: false,
  //           enableQuerySyntax: false,
  //           pipeline: "events",
  //           context: {
  //             discipline,
  //             country,
  //             cs_uid,
  //             classification,
  //             market,
  //           },
  //         }),
  //       })

  //       const response = await fetch(request)
  //       if (response.ok) {
  //         const body = await response.json()
  //         return [null, body]
  //       }
  //     } catch (error) {
  //       return [error, null]
  //     }
  //   },
  //   true
  // )

  // overrides UI components
  const parentEvent = event?.parent_element?.[0]
  const aggregator = getAggregatorPath(event)
  const eventPath = `/${[aggregator, discipline, parentEvent?.slug, slug].filter(Boolean).join("/")}`

  if (controlsLayout) {
    if (!ssr) header.children = <SubNav /*ariaLabel={discipline} cta={[{ link: { href: `/${aggregator}`, label: dictionary.rolexEvent() } }]}*/ />
    footer.breadcrumb = [
      // Temporary: arts aggregator and discipline pages are not available yet.
      ...(aggregator === aggregatorPathByTerm.arts
        ? []
        : [
            { title: dictionary[camelCase(aggregator)](), href: `/${aggregator}` },
            { title: dictionary[camelCase(discipline)](), href: `/${aggregator}/${discipline}` },
          ]),
      ...(parentEvent?.slug
        ? [
            {
              title: parentEvent.name ?? parentEvent.slug,
              href: `/${aggregator}/${discipline}/${parentEvent.slug}`,
            },
          ]
        : []),
      { title: event?.name, href: eventPath },
    ]
  }

  const coverImage = event?.cover?.asset?.find(({ resource_type }) => resource_type === "image")
  const searchImage = event?.meta?.search_image?.[0]

  function generateMetaImageUrl(source, secureDistribution) {
    if (!source) return null
    const src = typeof source === "string" ? { public_id: source } : source
    return imageLoader({ src }, { ...env, cloudinary: { ...env.cloudinary, secureDistribution } })({ width: 2440, quality: "auto:eco" })
  }

  function generateMetaTag(name, source, secureDistribution) {
    const url = generateMetaImageUrl(source, secureDistribution)
    if (!url) return null
    return name.startsWith("og:") ? <meta property={name} content={url.href} /> : <meta name={name} content={url.href} />
  }

  const ldJsonImage = generateMetaImageUrl(coverImage, secureDistribution)?.href

  const ldJson = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: event?.name,
    url: eventPath,
    ...(ldJsonImage && { image: ldJsonImage }),
    description: event?.meta?.description,
    ...(event?.startDate && { startDate: event.startDate }),
    ...(event?.endDate && { endDate: event.endDate }),
    location: {
      "@type": "Place",
      name: event?.location?.name,
      address: event?.location?.address,
    },
  }

  console.log("BootstrapEvent(%o)", { event, page })

  return (
    <>
      {eventSSR}
      {/* {eventsSSR} */}
      <Helmet>
        <title>{event?.meta?.title}</title>
        <meta name='description' content={event?.meta?.description} />
        {event?.meta?.title && <meta property='og:title' content={event?.meta?.title} />}
        {event?.meta?.description && <meta property='og:description' content={event?.meta?.description} />}
        <meta name='search_title' content={event?.name} />
        <meta name='search_section' content={dictionary.rolexEvent()} />
        {event?.meta?.search_exclude === true && <meta name='search_exclude' content='true' />}
        {generateMetaTag("image", coverImage, secureDistribution)}
        {generateMetaTag("og:image", coverImage, secureDistribution)}
        {generateMetaTag("searchimage", searchImage, secureDistribution)}
        {generateMetaTag("og:searchimage", searchImage, secureDistribution)}
        <script type='application/ld+json'>{JSON.stringify(ldJson)}</script>
      </Helmet>
      {controlsLayout && generateComponents(header, { console })}
      {controlsLayout && generateComponents(props.subNav, { console })}
      {controlsLayout && props.back && <Back />}
      {controlsLayout && props.tools && <Tools {...props.tools} />}
      {controlsLayout ? (
        <main
          id='main'
          style={{
            "--is-sub": !ssr && document.querySelector(".header-subnav") ? 1 : 0,
          }}
        >
          <Event {...props} discipline={discipline} event={event} /*events={events}*/ share={share} />
        </main>
      ) : (
        <Event {...props} discipline={discipline} event={event} /*events={events}*/ share={share} />
      )}
      {controlsLayout && !nofooter && generateComponents(footer, { console })}
    </>
  )
}

export function Event({ event, /*events,*/ discipline, share }) {
  const console = useConsole()

  const { cover, name, baseline, introduction, content, start_date, end_date, labels, keep_exploring } = event
  // const { results: eventRecommandations } = events || []

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0)
    }, 300)
  }, [])

  const extendedContent = [
    {
      content: [{ text: { name, baseline, ...(cover.title && { title: cover.title }), is_rftc: cover.is_rftc ?? false } }, { asset: cover }],
      _metadata: { uid: "cover" },
      component_type: "cover",
      theme: cover.theme.theme ?? "dark-theme",
    },
    ...(introduction?.paragraph
      ? [{ content: [{ text: introduction, discipline }], _metadata: { uid: "introduction" }, component_type: "introduction", theme: "light-theme" }]
      : []),
    ...content,
  ]

  console.log("Event(%o)", { extendedContent, start_date, end_date, labels, keep_exploring })

  return (
    <>
      <Content content={extendedContent} event={event} name={name} /*share={share}*/ />
      {/* <Suspense>
        <TestimoneeExplore searchUid={event.searchUid} uid={event.uid} testimoneeRecommandations={[]} keep_exploring={keep_exploring} />
      </Suspense> */}
    </>
  )
}
